import apiClient from "./client";

export const getCareerJobs = async () => {
  const response = await apiClient.get("/careers");
  return response.data;
};

export const getCareerJobByKey = async (jobKey) => {
  const response = await apiClient.get(`/careers/${encodeURIComponent(jobKey)}`);
  return response.data;
};

export const applyCareerJob = async ({ jobId, payload }) => {
  const response = await apiClient.post(`/careers/${jobId}/apply`, payload, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};
